import { useParams } from "react-router-dom";
import { useFetch, usePost, useDelete } from "./common/Hook";
import { useEffect, useLayoutEffect, useRef, useState } from "react";

function App() {
    let { id } = useParams();
    const inputName = useRef();
    const [username, setusername] = useState("");
    const [isUsed , setisused] = useState(false);
    const { doFetch, data, isLoading, isError, setUrl } = useFetch("https://blm4nhm9j3.execute-api.ap-northeast-1.amazonaws.com/items/" + id);
    const { doPost, isSuccess, isPosting, isPostError, message } = usePost("https://blm4nhm9j3.execute-api.ap-northeast-1.amazonaws.com/items");
    const { doDelete, isSuccess_2, isPosting_2, isPostError_2, message_2 } = useDelete("https://blm4nhm9j3.execute-api.ap-northeast-1.amazonaws.com/items/" + id);


    useEffect(
        () => {
            doFetch();
        }, []
    )

    useEffect(
        () => {
            if (data != null) {
                console.log(data);
                setusername(data.UserName);
                setisused(true)
            }
            else {
                setusername("");
                setisused(false)
            }
        }, [data]
    )

    const submit = e => {
        e.preventDefault();
        let param = {
            DeskId: id,
            UserName: inputName.current.value,
        };
        const paramJSON = JSON.stringify(param);
        console.log(paramJSON);
        doPost(paramJSON);
        setusername(inputName.current.value)
        setisused(true);
        inputName.current.value ="";

    }

    const deleteid = e => {
        e.preventDefault();
        let param = {
            DeskId: id
        };
        const paramJSON = JSON.stringify(param);
        doDelete(paramJSON);
        setusername("")
        setisused(false);

    }

    /*  
    const reload = e => {
           e.preventDefault();
           setusername("");
           doFetch();
       }
       */
return (
        <div>
             <nav class="navbar has-background-dark " role="navigation" aria-label="navigation">
                 <div class="navbar-brand">
                     <span class="navbar-item has-text-primary-95 title is-4 has-text-weight-normal" 
                     style={{"letter-spacing":"0.2em"}}>
                         座席操作
                         </span>
                 </div>
             </nav>
             <div class="block p-2">
                <div class="card">
                    <div class={isUsed ? "card-header has-background-primary" :  "card-header" }>
                        <p class="card-header-title">DeskNo：{id}</p>
                    </div>
                    <div class="card-content">
                        
                        <div class={isUsed ? "content icon-text has-text-primary" :  "content icon-text has-text-grey" }>
                              <span class="icon is-medium">
                                <i class="fas fa-info-circle fa-lg"></i>
                              </span>
                              <span class="pt-1">着席状況</span>
                        </div>
                        <div class="content">
                            {
                            (() => {
                                if(isLoading){
                                    return(
                                        <div class="content icon-text  has-text-grey">
                                              <span class="icon is-large">
                                                <i class="fas fa-spinner fa-spin fa-2x"></i>
                                              </span>
                                        </div>
                                        //<progress class="progress is-primary mr-3" max="50">50%</progress>
                                    )
                                }else if (isUsed){
                                    return(
                                    <span>{username}さんが使用しています</span>
                                    )

                                }else{
                                    return(
                                    <span>空席です</span>
                                    )
                                }
                                })()
                            }
                        </div>
                         <hr />
                        <div class="content">

                            <div class="field is-grouped">

                                <form onSubmit={submit}>
                                    <div class="field has-addons">
                                        <p class="control">
                                          <input class="input" type="text" placeholder="氏名を入力" ref={inputName} required autocomplete="username" />
                                            {isUsed && <p class="help is-primary-light">利用者を上書きで変更します。</p>}
                                        </p>
                                        <p class="control">
                                            <button class="button is-primary">{"着席"}</button>
                                        </p>
                                    </div>
                                </form>
                                <form onSubmit={deleteid}>
                                    <div class="control">
                                        {
                                            (()=>{
                                             if(isUsed){
                                                 return ( <button class="button is-dark" >{"離席"}</button> );
                                             }else{
                                                  return ( <button class="button is-dark" disabled>{"離席"}</button> );
                                             }
                                                
                                            })()
                                        }
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                <footer class="footer mt-1">
                  <div class="content has-text-centered">
                        <div class="icon-text has-text-grey-light">
                           <span class="">Powered by </span>
                            <span class="icon">
                                  <i class="fas fa-code"></i>
                            </span>
                            <span class="">遊学団</span>
                        </div>
                  </div>
                </footer>
            </div>   
                
                {/*
                 <form onSubmit={reload}>
                    <button>{"更新"}</button>
                </form>
                */}
        </div>
    );

}

export default App;
